<template>
  <div class="bg_gray" style="overflow:hidden;">
    <Header navTitle="我的收藏" navPath="/mobile/center"></Header>
    <div class="container bg_gray">
      <LoadList v-if="list.length > 0" :pager="pager" v-model:loading="loading" @getPager="getPager">
        <van-checkbox-group v-model="selectedRows">
          <van-swipe-cell v-for="(item, index) in list" :key="index" :before-close="listBeforeClose" class="list">
            <div class="course_item_wrap">
              <div class="course_item_common">
                <div class="select" @click="listCheckToggle(index)">
                      <van-checkbox icon-size="15" :name="item" v-model="item.is_checked" shape="square" :ref="el => listCheckRefs[index] = el" checked-color="#52c41a" @click.stop></van-checkbox>
                </div>
                <div class="cover" @click="goPath('/mobile/course/detail/'  + item.uuid)">
                  <img :src="item.cover_image" />
                  <div v-if="item.cover_image_label != ''">
                    <span class="hot" v-if="item.cover_image_label && item.cover_image_label != 'null'">{{ item.cover_image_label }}</span>
                  </div>
                  <span class="tag" v-if="item.type">{{item.type }}</span>
                  <div v-if="item.state !=3 || item.deleted">
                    <div class="layer">已失效</div>
                  </div>
                </div>
                <div class="content">
                  <h4 @click="goPath('/mobile/course/detail/'  + item.uuid)" class="text_ellipsis">{{ item.name }}</h4>
                  <div class="info">
                    章节数：{{ item.chapter_num }}章{{get_course_num(item)}}节
                  </div>
                </div>
              </div>
            </div>
            <template #right>
              <van-button square text="移除" type="danger" style="height:100%;" @click="delFavor(item.uuid)" />
            </template>
          </van-swipe-cell>
        </van-checkbox-group>
      </LoadList>
      <van-empty v-if="is_loaded && list.length == 0" description="暂无内容哦~"></van-empty>
    </div>


    <!-- 操作底板 -->
    <div class="sheet_fixed_bottom_common">
      <div class="text-right">
        <van-button  type="danger" :disabled="disabledDel" @click="delFavor(0)">移除</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from 'components/mobile/common/Header'
  import Pagination from 'components/common/Pagination'
  import { unlike, get_user_favors, get_invalid_favors } from "api/course/course/create"
  import { showConfirmMessageBox, showMessage } from 'api/base/mobile/message'
  import LoadList from "components/mobile/common/LoadList"
  export default {
    components: {
      Header,
      // Pagination,
      LoadList
    },
    data() {
      return {
        listCheckRefs: [],
        list: [],
        selectedRows: [],
        loading: false,
        is_loaded: false,
        pager: {

        },
        disabledDel: 'disabled',
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', false);
      this.pager = {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
      this.getPager(this.pager)
    },
    methods: {
      listBeforeClose(val) {
        if(val.position === 'left') {
          return false
        }
      },
      listCheckToggle(index) {
        this.listCheckRefs[index].toggle();
      },
      checkbox(row, index){
        if (row.state != 3 || row.deleted){
          return false
        }else{
          return true
        }

      },
      get_course_num(row){
        let ret = row.live_num + row.face_num + row.video_num + row.auth_num + row.experiment_num
        return ret
      },
      setData(pager){
        const that = this;
        var data = {}
        data['offset'] = (that.pager.currentPage - 1) * that.pager.pageSize
        data['limit'] = that.pager.pageSize
        this.loading = true
        this.$emit('update:isShowOverlay', true);
        get_user_favors(data).then((res) => {
          if(!pager){
            that.list = []
          }
          console.log(res.data)
          that.list.push(...res.data)
          that.pager.total = res.total
          that.loading = false
          that.$emit('update:isShowOverlay', false);
          that.is_loaded = true
        }).catch(err => {
          showMessage(err)
        });
      },
      delFavor(uuid) {
        var that = this
        showConfirmMessageBox('确定要移除吗？')
          .then(() => {
            that.list = []
            if(uuid == 0){
              this.selectedRows.forEach(res => {
                unlike({'target_uuid': res.uuid, 'target_type': 'favor'}).then(res => {
                  that.setData(false)
                })
              })
              this.selectedRows = []
            }else{
              unlike({'target_uuid': uuid, 'target_type': 'favor'}).then(res => {
                that.setData(false)
              })
            }
          })
      },
      goPath(path) {
        this.$router.push(path)
      },
      selectChange() {
        if(this.selectedRows.length == 0){
          this.disabledDel = 'disabled'
        }else{
          this.disabledDel = false
        }
      },
      getPager(pager) { //获取分页变化后数据
        this.pager = pager
        this.setData(true)
      },
      handleCommandOrder(command) {  //批量操作
        if (command === 'del') {
          this.delFavor(0)
        }
      },
      delInvalidFavor(){
        var that = this
        showConfirmMessageBox('确定要移除吗？')
          .then(() => {
            get_invalid_favors().then((res) => {
              res.data.forEach(favor => {
                unlike({'target_uuid': favor.uuid, 'target_type': 'favor'}).then(res => {
                  that.setData(false)
                })
              })
            })

          })
      }
    },
    watch: {
      selectedRows: {
        handler(val) {
          this.selectChange()
        },
        deep:true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    padding: 10px 0;
    .list {
      margin-bottom:10px;
    }
    .course_item_common {
      .select {
        display: flex;
        padding-left: 10px;
      }
    }
  }
</style>
